import UrlService from '../../../services/UrlService';
import axiosActions from '../axiosHelpers';
import { getSelectedCompany } from '../../selectors';
import { uuidv4 } from '../../../utils/uuid';

export const FETCH_CARRIERS = axiosActions('FETCH_CARRIERS');
export const FETCH_GIVEN_CONSENTS = axiosActions('FETCH_GIVEN_CONSENTS');
export const GRANT_PREDEFINED_LOCATION_CONSENT = axiosActions('GRANT_PREDEFINED_LOCATION_CONSENT');
export const REVOKE_PREDEFINED_LOCATION_CONSENT = axiosActions('REVOKE_PREDEFINED_LOCATION_CONSENT');

const executeSearchCarriers = (companyId, silentRefresh = false, requestBody) => ({
  type: FETCH_CARRIERS.START,
  payload: {
    actionId: uuidv4(),
    silentRefresh,
    request: {
      method: 'post',
      url: UrlService.carriersInvitationSearch(companyId),
      data: requestBody,
    },
  },
});

const executeLoadGivenConsents = (companyId, silentRefresh = false) => ({
  type: FETCH_GIVEN_CONSENTS.START,
  payload: {
    actionId: uuidv4(),
    silentRefresh,
    request: {
      method: 'get',
      url: UrlService.companyGivenConsents(companyId),
    },
  },
});

const executeGrantPredefinedLocationConsent = (companyId, recipientCompanyId) => ({
  type: GRANT_PREDEFINED_LOCATION_CONSENT.START,
  payload: {
    request: {
      method: 'post',
      url: UrlService.companyPredefinedLocationConsents(companyId),
      data: {
        recipientCompanyId,
      },
    },
  },
});

const executeRevokePredefinedLocationConsent = (companyId, consentId) => ({
  type: REVOKE_PREDEFINED_LOCATION_CONSENT.START,
  payload: {
    request: {
      method: 'post',
      url: UrlService.companyPredefinedLocationConsentRevoke(companyId, consentId),
    },
  },
});
// eslint-disable-next-line
export const loadInvitedCarriers = (silentRefresh = false, requestBody = { pageNumber: 0, pageSize: 20 }) => (dispatch, getState) => {
  const state = getState();
  const selectedCompany = getSelectedCompany(state);
  return dispatch(executeSearchCarriers(selectedCompany, silentRefresh, requestBody));
};

// eslint-disable-next-line
export const loadGivenConsents = (silentRefresh = false) => (dispatch, getState) => {
  const state = getState();
  const selectedCompany = getSelectedCompany(state);
  return dispatch(executeLoadGivenConsents(selectedCompany, silentRefresh));
};

// eslint-disable-next-line
export const grantPredefinedLocationConsent = (recipientCompanyId) => (dispatch, getState) => {
  const state = getState();
  const selectedCompany = getSelectedCompany(state);
  return dispatch(executeGrantPredefinedLocationConsent(selectedCompany, recipientCompanyId))
    .then(() => {
      dispatch(loadGivenConsents(true));
    });
};

// eslint-disable-next-line
export const revokePredefinedLocationConsent = (consentId) => (dispatch, getState) => {
  const state = getState();
  const selectedCompany = getSelectedCompany(state);
  return dispatch(executeRevokePredefinedLocationConsent(selectedCompany, consentId))
    .then(() => {
      dispatch(loadGivenConsents(true));
    });
};
